import { useState, useEffect } from 'react';
import BuyerHero from './BuyerHero';
import { FaqSection } from './faq-section';
import { getPageSettings } from "../../services/pagesettingServices.ts";
import { useLanguage } from '../../context/LanguageContext';
import BuyerPackagePlans from './BuyerPackage.jsx';
import { Helmet } from "react-helmet";
import usePageMeta from '../../hooks/usePageMeta.js';
function Buyer() {
  const { language } = useLanguage();
 usePageMeta("buyer");
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSettings, setPageSettings] = useState(null);

  useEffect(() => {
    const fetchBuyerData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch both FAQs and Page Settings (Meta data)
        // Adjust the "page" slug if your backend uses a different name for the Buyer page settings
        const response = await getPageSettings({
          page: "buyer", 
          lang: language,
        });

        // 1. Set Page Settings (for Meta Tags)
        setPageSettings(response);

        // 2. Set FAQs 
        // Note: Check if FAQs are part of the 'buyer' response or require a separate 'buyerfaqs' call
        const faqsData = response?.buyer_faqs || response?.data?.buyer_faqs || [];
        console.log("Fetched FAQs:", faqsData);
        setFaqs(faqsData);

      } catch (err) {
        console.error("❌ Error fetching buyer data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBuyerData();
  }, [language]);

  // Safely extract metadata with fallbacks
  const metaDescription = pageSettings?.meta_fields?.[0]?.meta_description?.value || "Default description";
  const metaKeywords = pageSettings?.meta_fields?.[0]?.meta_keywords?.value || "default, keywords";
  const pageTitle = pageSettings?.hero_banner?.[0]?.title?.value || "Buyer Page";

  return (
    <main className="bg-bg-dark text-foreground">
      {/* <Helmet>
        {/* Helmet will dynamically update the <head> when these variables change 
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet> */}

      <BuyerHero />
      <BuyerPackagePlans />

      <FaqSection
        faqs={faqs}
        loading={loading}
        error={error}
      />
    </main>
  );
}

export default Buyer;